import { createElement, useContext } from 'react'

// Node Modules
import { DomElement } from 'html-react-parser'

// Components
import DocumentImage from 'components/DocumentImage'

// Context
import { LanguageContext } from 'context/language-context'
import { DocsetContext } from 'context/content-context'

// Util
import { docsetImage } from 'util/links'
import { HELP_DOCSET_ALIAS, HELP_DOCSET_CFR} from 'util/constants'

export default (node:DomElement, params:any, options:any) => {
  const language = useContext(LanguageContext)
  const docset = useContext(DocsetContext)
  const { src, alt, style, width, height } = node.attribs as any
  


  let srcOverride = src

  if (docset) {
    const [, file] = src.split('images/')

    srcOverride = docsetImage(params.help ? HELP_DOCSET_ALIAS : docset.id, params.help ? HELP_DOCSET_CFR : docset.version, file, language)
  }

  let innerStyle = style

  return createElement(
    DocumentImage, 
    { 
      src: srcOverride, 
      alt,
      innerStyle,
      width,
      height
    }
  )
}